import React from 'react';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import FlexRow from '@ff/ui/FlexRow';
import FlexCol from '@ff/ui/FlexCol';
import Image from '@ff/ui/Image';
import Link from '@ff/ui/Link';
import Text from '@ff/ui/Text';
import type { Props as PropsSchema } from './props-schema';
import ArrowSVG from './Icons/arrow.svg';

export interface Props {
  bioList: PropsSchema['bioList'];
  textColor: PropsSchema['textColor'];
}

export default function SingleCard(props: Props) {
  const { bioList, textColor } = props;

  return (
    <Container>
      {bioList.map((item) => (
        <>
          <ProfileContainer>
            <Profile profileRoundedCorner={item?.profileRoundedCorner} src={item.profileUrl} alt={item.profileUrlAlt || 'profile'} />
          </ProfileContainer>
          <TextContainer>
            <Title nameColor={textColor?.bioListColor?.nameColor}>{item.name}</Title>
            <Subtitle positionColor={textColor?.bioListColor?.positionColor}>{item.position}</Subtitle>
            <Description bioColor={textColor?.bioListColor?.bioColor}>{item.bio}</Description>
            {item?.link && (
              <ArrowLink href={item.link}>
                <StyledArrow src={ArrowSVG} />
              </ArrowLink>
            )}
          </TextContainer>
        </>
      ))}
    </Container>
  );
}

const Container = styled(FlexRow)({
  marginTop: '45px',
  height: '700px',
  maxWidth: '1438px',
  width: '90vw',
  borderRadius: '4px',
  backgroundColor: 'rgba(0, 0, 0, 1)',
});

const ProfileContainer = styled(Box)({
  maxHeight: '700px',
  maxWidth: '700px',
  minWidth: '500px'
});

const Profile = styled(Image)<{ profileRoundedCorner: boolean }>(({ profileRoundedCorner }) => ({
  borderRadius: profileRoundedCorner ? '12px' : 0,
  objectFit: 'cover',
  objectPosition: 'bottom',
  height: '100%'
}));

const TextContainer = styled(FlexCol)({
  justifyContent: 'center',
  maxWidth: '556px',
  padding: '32px'
});

const Title = styled(Text)<{ nameColor: string }>(({ nameColor }) => ({
  color: nameColor || 'white',
  fontSize: '24px',
  fontWeight: 500,
  lineHeight: '30px',
  marginTop: '16px',
  marginBottom: '2px'
}));

const Subtitle = styled(Text)<{ positionColor: string }>(({ positionColor }) => ({
  color: positionColor || '#C9C9D1',
  fontSize: '14px',
  lineHeight: '22px',
  marginBottom: '16px'
}));

const Description = styled(Text)<{ bioColor: string }>(({ bioColor }) => ({
  color: bioColor || 'rgba(255, 255, 255, 0.67)',
  fontSize: '16px',
  lineHeight: '24px',
}));

const ArrowLink = styled(Link)({
  marginTop: '24px',
  width: 'fit-content',
});

const StyledArrow = styled(Image)({
  height: '14px',
  width: '14px',
});